import { useTheme } from '@app/styled';

const AiLogo = () => {
    const theme = useTheme();

    return (
        <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_306_64835)">
                <path
                    d="M23.8953 0H6.10471C2.73317 0 0 2.7556 0 6.1548V23.8452C0 27.2444 2.73317 30 6.10471 30H23.8953C27.2668 30 30 27.2444 30 23.8452V6.1548C30 2.7556 27.2668 0 23.8953 0Z"
                    fill={theme.color.custom.background.primary}
                />
                <path
                    d="M23 16.789V13.2085L19.8945 11.4159L19.064 10.9361L18.5841 10.1055L16.789 7H13.2085L11.4159 10.1055L10.9361 10.9361L10.1055 11.4159L7 13.211V16.7915L10.1055 18.584L10.9361 19.0639L11.4159 19.8945L13.2085 23H16.789L18.5816 19.8945L19.0615 19.0639L19.892 18.584L22.9976 16.7915L23 16.789ZM15.0012 19.8994L13.2085 16.7939L10.1031 15.0012L13.2085 13.2085L15.0012 10.1031L16.7939 13.2085L19.8993 15.0012L16.7939 16.7939L15.0012 19.8994Z"
                    fill={theme.color.custom.lokaliseAi.logo}
                />
            </g>
            <defs>
                <clipPath id="clip0_306_64835">
                    <rect width="30" height="30" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default AiLogo;
